import { m } from "framer-motion"
import { useState } from "react"
import { Col } from "react-bootstrap"
import Documents from "./Components/Documents"
import SectionFour from "./Components/SectionFour"
import PMU from "./Components/PMU"

const Rti = () => {
    const [activeButton, setActiveButton] = useState(1)
    const rtiButtons = [
        'Documents',
        'PMU',
        'Section 4(1)'
    ]

    const updateButton = (index) => {
        setActiveButton(index)
    }

    return (
        <>
            <m.div className='container  mt-[200px] '>
                <Col xl={8} lg={10} className="text-center w-fit">
                    <h3 className="font-serif text-[30px] mb-[2px]  font-medium text-[#146084] -tracking-[1px]">Right to Information</h3>
                    <m.div
                    className="border-b border-1 w-[40%] border-[#146084]"
                    initial={{ scaleX: 0 }}
                    animate={{ scaleX: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                />
                </Col>

                <div className="w-[100%] mb-[30px] flex justify-center">
                    <div className="flex w-[60%] sm:w-[100%] justify-center mt-[30px] gap-[10px] sm:flex-col">
                        {rtiButtons.map((name, index) =>
                            <button onClick={() => updateButton(index + 1)} className={`${activeButton === index + 1 ? 'text-[white] bg-[#146084] delay-100 animate-pulse' : 'text-[#146084] border-2 border-[#146084]'} p-[10px] px-[50px]  `}>
                                {name}
                            </button>
                        )}


                    </div>
                </div>

                {activeButton === 1 ?
                    <Documents />
                    :
                    activeButton === 2 ?
                        <PMU />
                        :
                        activeButton === 3 ?
                            <SectionFour />
                            : ''
                }
            </m.div >
        </>
    )
}

export default Rti